import {ErrorMessage} from 'ng-bootstrap-form-validation';
import { ValidatorFn, AbstractControl, Validators } from '@angular/forms';

export const CUSTOM_ERRORS: ErrorMessage[] = [
  {
    error: 'required',
    format: requiredFormat
  }, {
    error: 'email',
    format: emailFormat
  },
  {
      error: 'password',
      format: passwordFormat
  },
  {
    error: 'pattern',
    format: patternFormat
  },
  {
    error: 'max',
    format: patternFormat
  },
  {
    error: 'min',
    format: patternFormat
  }
];

export function requiredWithSuppression(suppress: boolean): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (suppress) {
      return null;
    }
    return Validators.required(control);
  };
}

export function requiredFormat(label: string, error: any): string {
  return `O valor deve ser informado`;
}

export function emailFormat(label: string, error: any): string {
  return `Verifique o e-mail`;
}

export function passwordFormat(label: string, error: any): string {
    return `A senha deve ser informada`;
  }

export function patternFormat(label: string, error: any): string {
    return `Verifique o valor`;
}
